import { Component, OnInit, Injector } from '@angular/core';
import { DialogConfig, DialogService } from '@tmhcc-ng-lib/framwork/dialog';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import {
  FormValidatorService,
  ContactusService
} from '@tmhcc-ng-lib/content-service';
import { ContactUs } from 'libs/content-service/def/contactus';
import { getBaseUri } from '@tmhcc/util';

@Component({
  selector: 'ae-contact-model',
  templateUrl: './contact-model.component.html',
  styleUrls: ['./contact-model.component.scss']
})
export class ContactModelComponent implements OnInit {
  contactFlag: boolean = false;
  contactUsForm: FormGroup;
  submitted = false;
  sitecoreContent: ContactUs;
  formLabels;
  actionUrl;
  orgid;
  debug;
  isDataAvailable: boolean = false;
  formFields: any = {};
  phoneNumber = '^(+d{1,3}[- ]?)?d{10}$';
  contactUsReturnUrl: string;
  constructor(
    public dialogData: DialogConfig,
    public dialogService: DialogService,
    private fb: FormBuilder,
    private formValidatorService: FormValidatorService,
    private contactusService: ContactusService
  ) {}

  ngOnInit(): void {
    this.contactUsReturnUrl = getBaseUri() + '/bound/boundpolicy';
    this.contactUsForm = this.fb.group({
      name: [''],
      email: [''],
      telephone: ['', Validators.pattern('^((\\+91-?)|0)?[0-9]{10}$')],
      policyNumber: [''],
      assistance: [''],
      issueDetail: ['']
    });
    this.setValue();
    this.contactusService.data$.subscribe(res => {
      if (res) {
        this.dialogData.modalSetting.title = res.forms[0].formName;
        this.contactusData(res.data[0]);
        this.formLabels = res;
        this.actionUrl = res.forms[1].fields.filter(items => {
          return items.fieldInfo.fieldName == 'retURL';
        });
        this.orgid = res.forms[1].fields.filter(items => {
          return items.fieldInfo.fieldName == 'orgid';
        });
        this.debug = res.forms[1].fields.filter(items => {
          return items.fieldInfo.fieldName == 'debug';
        });
        //Filter field object
        this.formFields.nameField = this.fetchFormFields(
          res.forms[0].fields,
          'Name'
        );
        this.formFields.emailField = this.fetchFormFields(
          res.forms[0].fields,
          'Email'
        );
        this.formFields.telephoneField = this.fetchFormFields(
          res.forms[0].fields,
          'Telephone'
        );
        this.formFields.policySubmissionField = this.fetchFormFields(
          res.forms[0].fields,
          'Policy or Submission Number'
        );
        this.formFields.assistanceField = this.fetchFormFields(
          res.forms[0].fields,
          'What would you like assistance with?'
        );
        this.formFields.issueDetailField = this.fetchFormFields(
          res.forms[0].fields,
          'Please provide as much detail as possible regarding the issue you are experiencing'
        );

        //Validation
        const nameValidations = this.formValidatorService.setFormValidator(
          this.formFields.nameField
        );
        const emailValidations = this.formValidatorService.setFormValidator(
          this.formFields.emailField
        );
        const telephoneValidations = this.formValidatorService.setFormValidator(
          this.formFields.telephoneField
        );
        const policySubmissionField = this.formValidatorService.setFormValidator(
          this.formFields.policySubmissionField
        );
        const assistanceField = this.formValidatorService.setFormValidator(
          this.formFields.assistanceField
        );
        const issueDetailField = this.formValidatorService.setFormValidator(
          this.formFields.issueDetailField
        );
        this.f.name.setValidators(nameValidations);
        this.f.name['requiredError'] = this.fetchValidationValue(
          this.formFields.nameField.fieldInfo.validations,
          'Required'
        ).value;
        this.f.email.setValidators(emailValidations);
        this.f.email['requiredError'] = this.fetchValidationValue(
          this.formFields.emailField.fieldInfo.validations,
          'Required'
        ).value;
        this.f.email['validEmailError'] = this.fetchValidationValue(
          this.formFields.emailField.fieldInfo.validations,
          'EmailValid'
        ).value;
        this.f.telephone.setValidators(telephoneValidations);
        this.f.telephone['requiredError'] = this.fetchValidationValue(
          this.formFields.telephoneField.fieldInfo.validations,
          'Required'
        ).value;
        this.f.policyNumber.setValidators(policySubmissionField);
        this.f.policyNumber['requiredError'] = this.fetchValidationValue(
          this.formFields.policySubmissionField.fieldInfo.validations,
          'Required'
        ).value;
        this.f.assistance.setValidators(assistanceField);
        this.f.assistance['requiredError'] = this.fetchValidationValue(
          this.formFields.assistanceField.fieldInfo.validations,
          'Required'
        ).value;
        this.f.issueDetail.setValidators(issueDetailField);
        this.f.issueDetail['requiredError'] = this.fetchValidationValue(
          this.formFields.issueDetailField.fieldInfo.validations,
          'Required'
        ).value;
      }
    });
  }

  openContactForm(form) {
    if (form == 'contact') {
      this.contactFlag = true;
    } else {
      this.contactFlag = false;
    }
  }

  openChat() {
    //new boostai
    //if(sessionStorage.getItem('show-boostai') == 'true' && sessionStorage.getItem('UserId')){
    let windowobj= window as any;
    windowobj.boostChatStart();

   // }
this.cancel();
   // end of boostai
   
   //old code
    // (document.getElementsByClassName(
    //   'helpButtonEnabled uiButton'
    // )[0] as HTMLElement).click();
  }

  fetchValidationValue(validations: any[], key: string) {
    const filterObj = validations.filter(ele => ele.key == key);
    if (filterObj.length) return filterObj[0];
    return filterObj;
  }
  fetchFormFields(fields: any[], label: string) {
    const filterObj = fields.filter(ele => ele.fieldInfo.label == label);
    if (filterObj.length) return filterObj[0];
    return filterObj;
  }
  contactusData(data) {
    if (data) {
      this.sitecoreContent = data;
      this.isDataAvailable = true;
    }
  }
  get f() {
    return this.contactUsForm.controls;
  }

  setValue() {
    let formFields = JSON.parse(sessionStorage.getItem('userDetails'));
    if (formFields) {
      this.contactUsForm.patchValue({
        name: formFields.AgentInfo.Name,
        email: formFields.AgentInfo.Email,
        telephone: formFields.AgentInfo.Telephone,
        policyNumber: this.dialogData.data?.policyNum || ''
      });
    }
  }

  onSubmit() {
    this.submitted = true;
    // stop here if form is invalid
    if (this.contactUsForm.invalid) {
      return;
    } else {
      (document.getElementById('help-support') as HTMLFormElement).submit();
    }
  }
  cancel() {
    this.dialogService.close();
  }
  numberOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }
}
